module.exports = __webpack_public_path__ + "static/media/comp.7d8483be.png";